import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {get} from "lodash";
import { AuthContext } from "../../common/Auth"
import ImageRetrieval from "../ImageRetrieval";
import FaviconRetrieval from "../FaviconRetrieval";
import { useThemeSettings } from "../../layouts/state/useThemeSettings";

const LogoAndStoreName = (homeFive, menuStyleData) => {

  const { settingData, favicon, defaultUserGroup } = useContext(AuthContext)
  const [isgotimage, setisgotimage] = useState(false)
  const [logoImg, setLogoImg] =  useState(get(JSON.parse(localStorage.getItem("user")),"userImgGroup", ""))
  const {
    storeName,
    showLogo,
    logoWidth,
    showStoreName
  } = useThemeSettings({ settingData })

  useEffect(() => {
    if(defaultUserGroup?.groupLogo) {
      setLogoImg(defaultUserGroup?.groupLogo)
    }
  }, [defaultUserGroup])


  return (
    <div className="antera-text-logo-container container mt-1">
      <FaviconRetrieval favicon={favicon} />
      <div className="row" style={{ justifyContent: "center" }}>
        <div id="antera-logo-image-container image-container">
          {showLogo === true ? (
            logoImg !== "" ? (
              <figure className="pageLogo" style={{ maxWidth: logoWidth + "px" }}>
                <img
                  alt="logo"
                  className="mt-10 mb-2 mr-5"
                  src={logoImg}
                />
              </figure>
            ) : (
              <ImageRetrieval
                isHeader={homeFive?.footerlogoWidth ? false : true}
                className={homeFive ? "ml-20" : ""}
                logoWidth={logoWidth}
                footerlogoWidth={homeFive?.footerlogoWidth}
                isgotimage={isgotimage}
                setisgotimage={setisgotimage}
              />
            )
          ) : (
            ""
          )}
        </div>
        {showStoreName && (
          <div className="antera-logo-text-container row col-12">
            <h3
              className="antera-logo-text"
              style={{
                fontSize: logoWidth < 100 ? "20px" : null,
                fontFamily: menuStyleData.menuFont,
                color: menuStyleData.menuFontcolor,
                textAlign: "center",
                width: "100%",
              }}
            >
              {storeName?.length > 0 ? storeName.toString() : ""}
            </h3>
          </div>
        )}
      </div>
    </div>
  );
};

LogoAndStoreName.propTypes = {
  homeFive: PropTypes.bool,
  menuStyleData: PropTypes.any
};

export default LogoAndStoreName;
